import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "linkedin-1jgW_",
  "use": "linkedin-1jgW_-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"linkedin-1jgW_\"><path fill-rule=\"evenodd\" d=\"M3.115 4.258H.17v8.845h2.945V4.258zm.188-2.732C3.293.661 2.669 0 1.66 0 .66 0 0 .66 0 1.526c0 .848.634 1.527 1.624 1.527h.018c1.027 0 1.67-.679 1.66-1.527zm4.373 3.989V4.258H4.74s.035.83 0 8.845h2.936V8.167c0-.268.027-.527.098-.723.215-.527.697-1.071 1.509-1.071 1.062 0 1.49.812 1.49 2v4.73h2.937v-5.07c0-2.713-1.446-3.98-3.383-3.98-1.564 0-2.263.856-2.65 1.462z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol